<script lang="ts" module>
  namespace AiSuggestionHidden {
    export interface Props {
      onShowSuggestion: () => void;
    }
  }
</script>

<script lang="ts">
  let props: AiSuggestionHidden.Props = $props();
</script>

<p>
  Der <a
    class="shrink-0 cursor-pointer text-sm font-bold text-c-link underline"
    role="button"
    tabindex="0"
    href={undefined}
    onclick={props.onShowSuggestion}
    onkeydown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        props.onShowSuggestion();
      }
    }}
    >generierte Vorschlag
  </a> verschlechtert den TPI.
</p>
